var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27785",
    "data-name": "Group 27785",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13944",
    "data-name": "Rectangle 13944",
    width: 23,
    height: 23,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16547",
    "data-name": "Path 16547",
    d: "M18.232.645a3.316,3.316,0,0,0-4.008,0l-1,.82L2.54,10.145l-.023.019c-.005,0-.005.009-.011.009s-.028.028-.04.041-.006,0-.006.009-.017.023-.028.037-.005.009-.011.014-.011.023-.017.037-.005,0-.005.009L.029,16.115a.4.4,0,0,0,.136.47.644.644,0,0,0,.4.134A.811.811,0,0,0,.749,16.7l7.12-1.932c.005,0,.005,0,.011,0a.231.231,0,0,0,.051-.019.022.022,0,0,0,.012,0L8,14.709c.017-.009.034-.023.051-.032s.011,0,.011-.009.017-.009.023-.018l11.683-9.5a2.016,2.016,0,0,0,0-3.259ZM7.688,13.681,3.742,10.473l9.875-8.03,3.945,3.208Zm-4.5-2.355,3.447,2.8-5.176,1.4ZM18.969,4.5l-.6.493L14.422,1.788l.607-.493a1.987,1.987,0,0,1,2.4,0l1.542,1.254A1.212,1.212,0,0,1,18.969,4.5Zm0,0",
    transform: "translate(1.513 3.054)",
    fill: "#00aff1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.dd2935120d779cab4255d76cf68e07ef.svg";
export { ForwardRef as ReactComponent };